import {
  email as emailRegex,
  hexColor as hexColorRegex,
  rgbaColor as rgbaColorRegex,
  urlWithProtocol as urlWithProtocolRegex,
} from "./regexp";

export function isURLWithProtocol(value: string): boolean {
  return urlWithProtocolRegex.test(value);
}

export function isEmail(value: string): boolean {
  return emailRegex.test(value);
}

export function isHexColor(color: string): boolean {
  return hexColorRegex.test(color);
}

export function isRGBA(color: string): boolean {
  return rgbaColorRegex.test(color);
}

export function isColor(color: string): boolean {
  return isHexColor(color) || color === "transparent" || isRGBA(color);
}
